var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdgroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "#FFFBD6",
    stroke: "#D4A60C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.608 10.276L9.033 6.195C8.98633 6.07367 8.93733 5.93367 8.886 5.775C8.83467 5.61167 8.78567 5.439 8.739 5.257C8.641 5.635 8.54067 5.95 8.438 6.202L6.863 10.276H10.608ZM13.436 14H12.386C12.2647 14 12.1667 13.9697 12.092 13.909C12.0173 13.8483 11.9613 13.7713 11.924 13.678L10.986 11.256H6.485L5.547 13.678C5.519 13.762 5.46533 13.8367 5.386 13.902C5.30667 13.9673 5.20867 14 5.092 14H4.042L8.053 3.969H9.425L13.436 14Z",
    fill: "#D5A60C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdgroupIcon);
export default __webpack_public_path__ + "static/media/AdgroupIcon.815487e0072305fc09ef9adc7c7685a9.svg";
export { ForwardRef as ReactComponent };